import { ClosablePickerInstance } from "./types";

/**
 * 管理选择弹框实例，以便路由转换时统一处理
 */
const pickers: ClosablePickerInstance[] = [];

const PickerManager = {
  closeAllPicker: (): void => {
    pickers.forEach((picker) => picker.close());
  },

  addPicker: (instance: ClosablePickerInstance): void => {
    pickers.push(instance);
  },
};

export default PickerManager;
